<script lang="ts">
  export type GatKeyboardShortcutsProps = {
    shortcut?: string
    class?: HTMLAttributes['class']
  }

  // #ASC
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  import type { HTMLAttributes } from 'vue'
  const props = defineProps<GatKeyboardShortcutsProps>()
</script>
<template>
  <kbd
    :class="
      cn(
        'text-muted-foreground flex items-center justify-center rounded border bg-transparent px-2 text-xs',
        props.class
      )
    "
    ><slot>
      {{ shortcut }}
    </slot></kbd
  >
</template>
